import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { selectIsSmallScreen } from 'store/pageStore';
import { bannerStyles, bannerTextStyles, yellowBackground } from './styles';

export const Banner = () => {
	const isSmallScreen = useSelector(selectIsSmallScreen);

	return (
		<section className={`${yellowBackground}`}>
			<div className={`${bannerStyles}`}>
				<div className={`${bannerTextStyles}`}>
					<Typography variant="h1" className="banner-h1" as="h1">
						Черновой ремонт
					</Typography>
					<Typography
						variant={isSmallScreen ? 'm' : 'l'}
						size="body_long"
						className="banner-caption"
					>
						Подберём необходимые материалы, выполним черновые работы быстро и
						качественно
					</Typography>
				</div>
			</div>
		</section>
	);
};
